// Core
import React from 'react';
// Styles
import './Icon.css';

const Icon = props => {
    return <i className="material-icons">{props.icon}</i>;
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js